<div class="modal-header">
  <h5 class="modal-title">
    {{ 'liberacaomanual.titulo' | translate }} <span
      class="font-weight-light">{{ 'liberacaomanual.sub_titulo' | translate }}</span> <span
      class="text-muted">#{{ this.id }}</span> <br>
    <small class="text-muted" *ngIf="id == 0">{{'liberacaomanual.descricao_titulo' | translate }}</small>
  </h5>

  <button type="button" class="close" (click)="activeModal.dismiss(null)">&times;</button>
</div>

<!-- Form -->
<form [formGroup]="form" #ngForm="ngForm" (ngSubmit)="onSubmit()" novalidate>
  <div class="modal-body">

    <div class="form-row">

      <div class="form-group col-md-12">
        <label class="form-label">{{ 'liberacaomanual.dispositivo' | translate }}</label>
        <code>*</code>
        <ng-select (focus)="selectDispositivo.open()" #selectDispositivo [multiple]="false" [closeOnSelect]="true"
          placeholder="{{ 'status.selecione' | translate}}" [hideSelected]="true" formControlName="fk_iddispositivo"
          id="fk_iddispositivo" clearAllText="{{ 'validation_form.clear_text' | translate }}"
          [items]="state.dispositivos" loadingText="{{ 'progress.loading' | translate }}" bindLabel="dis_descricao"
          bindValue="pk_iddispositivo" typeToSearchText="{{ 'validation_form.type_to_search' | translate }}"
          [loading]="loading[3]" (change)="onChangeDispositivo($event)" (clear)="onClearDispositivo()"
          (scrollToEnd)="onScrollToEndDispositivo(selectDispositivo.searchTerm)"
          (scroll)="onScrollDispositivo($event, selectDispositivo.searchTerm)" [virtualScroll]="true"
          [typeahead]="typeaheadDispositivo" (click)="onClickDispositivo()" [selectOnTab]="true">

        </ng-select>

        <div *ngIf="(submitted || f.fk_iddispositivo.touched) && f.fk_iddispositivo.invalid" class="text-danger">
          <div *ngIf="f.fk_iddispositivo.errors.required">{{ 'validation_form.required' | translate}}</div>
        </div>

        <div *ngIf="state.is404[3]" class="text-danger">
          <div>{{ 'validation_form.no_record' | translate}}</div>
        </div>
      </div>
      <div class="form-group col-md-12" *ngIf="state.leitores">
        <label class="form-label">{{ 'liberacaomanual.acesso' | translate }}</label>
        <code>*</code>
        <ng-select (focus)="selectAcesso.open()" #selectAcesso [multiple]="false" [closeOnSelect]="true"
          placeholder="{{ 'status.selecione' | translate}}" [hideSelected]="true" formControlName="fk_idleitor"
          id="fk_idleitor" [clearable]="false" clearAllText="{{ 'validation_form.clear_text' | translate }}"
          [items]="state.leitores" loadingText="{{ 'progress.loading' | translate }}" bindLabel="dis_descricao"
          bindValue="pk_iddispositivo" typeToSearchText="{{ 'validation_form.type_to_search' | translate }}"
          [loading]="loading[4]" (change)="onChangeLeitor($event)" [selectOnTab]="true" #selectLeitor>
        </ng-select>
        <div *ngIf="(submitted || f.fk_idleitor.touched) && f.fk_idleitor.invalid" class="text-danger">
          <div *ngIf="f.fk_idleitor.errors.required">{{ 'validation_form.required' | translate}}</div>
        </div>
      </div>
      <div class="form-group col-md-12">
        <label class="form-label">{{ 'liberacaomanual.search_title' | translate }}</label>
        <ng-select (focus)="selectAutorizadoPor.open()" #selectAutorizadoPor [multiple]="false" [closeOnSelect]="true"
          placeholder="{{ 'status.selecione' | translate}}" [hideSelected]="true" formControlName="fk_idusuario"
          id="fk_idusuario" clearAllText="{{ 'validation_form.clear_text' | translate }}" [items]="state.usuarios"
          loadingText="{{ 'progress.loading' | translate }}" bindLabel="usu_nome" bindValue="pk_idusuario"
          typeToSearchText="{{ 'validation_form.type_to_search' | translate }}" [loading]="loading[2]"
          (change)="onChangeAutorizadoPor($event)" (clear)="onClearAutorizadoPor()"
          (scrollToEnd)="onScrollToEndAutorizadoPor(selectAutorizadoPor.searchTerm)"
          (scroll)="onScrollAutorizadoPor($event, selectAutorizadoPor.searchTerm)" [virtualScroll]="true"
          minTermLength="3"
          [typeahead]="typeaheadAutorizadoPor" (click)="onClickAutorizadoPor()" [addTag]="false" [selectOnTab]="true">
          <ng-template ng-option-tmp let-item="item">
            {{ ('perfil_de_acesso.' + item.fk_idperfisdeacesso | translate) + ' - ' + item.usu_nome}}
          </ng-template>
        </ng-select>

        <div *ngIf="state.is404[2]" class="text-danger">
          <div>{{ 'validation_form.no_record' | translate}}</div>
        </div>
      </div>

      <div class="form-group col-md-12" *ngIf="veiculoView">
        <label class="form-label">{{ 'liberacaomanual.veiculo' | translate }}</label>
        <div class="rounded ui-bordered p-3" *ngIf="veiculoView.vei_placa">

          <a href="javascript:void(0)"
            class="text-body font-weight-semibold mb-2">{{ veiculoView.vei_placa | uppercase }}</a>
          &nbsp;-&nbsp;
          <span class="">{{ veiculoView.vei_nome }}</span>
          &nbsp;-&nbsp;
          <span class="text-muted">{{ veiculoView.cor_nome }}</span>
          <div class="media">
            <a *ngIf="veiculoView.vei_status == 'A'" class="badge badge-pill badge-success"
              href="javascript:void(0)">{{'status.ativo' | translate }}</a>
            <a *ngIf="veiculoView.vei_status == 'I'" class="badge badge-pill badge-danger"
              href="javascript:void(0)">{{'status.inativo' | translate }}</a>
          </div>
        </div>
      </div>

      <div class="form-group col-md-12">
        <label class="form-label">{{ 'liberacaomanual.tipo_liberacao' | translate }}</label>
        <code>*</code>
        <ng-select (focus)="select.open()" #select [multiple]="false" [closeOnSelect]="true"
          placeholder="{{ 'status.selecione' | translate}}" formControlName="fk_idtipocomando" id="fk_idtipocomando"
          [hideSelected]="true" [clearable]="false"
          [ngClass]="{ 'is-invalid': (submitted || f.fk_idtipocomando.touched) && f.fk_idtipocomando.invalid }">
          <ng-option value="6">{{'liberacaomanual.liberar_e_registrar' | translate}}</ng-option>
          <ng-option value="M">{{'liberacaomanual.somente_registrar' | translate}}</ng-option>
        </ng-select>

        <div *ngIf="(submitted || f.fk_idtipocomando.touched) && f.fk_idtipocomando.invalid" class="text-danger">
          <div *ngIf="f.fk_idtipocomando.errors.required">{{ 'validation_form.required' | translate}}</div>
        </div>

      </div>


    </div>

  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-between align-items-center">
      <div>

      </div>
      <div>

        <button type="button" class="btn btn-default mr-2"
          (click)="activeModal.close(null)">{{ 'botao.cancelar' | translate }}</button>

        <button type="submit" class="btn btn-primary" [ladda]="loading[0]"
          data-style="zoom-in">{{ 'liberacaomanual.salvar' | translate }}</button>
      </div>
    </div>


  </div>

</form>